
annualSurveyStates = ($stateProvider, TagUrl) ->
    'ngInject'

    url = new TagUrl()
        .addTagTypes(['program', 'location'])
        .setTagDefault('affiliation', 'all');

    $stateProvider.state 'reports.annualSurvey',
        url: url.buildUrl('/annual-survey'),
        params: url.params,
        data: {tagUrl: url},
        reloadOnSearch: false,
        templateUrl: 'reports/annualSurveyBase'
        controller: 'AnnualSurveyReportBaseController'
        controllerAs: '$ctrl'

    $stateProvider.state 'reports.annualSurvey.year',
        url: '/:year?{page:int}{sort}'
        params:
            page: value: 1, squash: true
            sort: value: 'name', squash: true
        reloadOnSearch: false
        templateUrl: 'reports/annualSurveyYear'
        controller: 'AnnualSurveyReportYearController'
        controllerAs: '$ctrl'

    $stateProvider.state 'program.reports.annualSurvey',
        url: '/annual-survey'
        templateUrl: 'reports/programAnnualSurvey'
        controller: 'ProgramAnnualSurveyReportController'
        controllerAs: '$ctrl'
        resolve:
            surveys: resoveProgramReportData


resoveProgramReportData = ($http, ApiUrl, program) ->
    'ngInject'

    url = ApiUrl('reports', 'annual_survey', 'program', program.id)
    return $http.get(url).then (data) -> data.data.items


getValidYears = () ->
    date = new Date()
    year = date.getFullYear()
    end = if date.getMonth() >= 9 then year else year - 1
    return [end..2015]


surveyColumns = [
    'applicants'
    'started_mental_toughness'
    'housing_units_completed'
    'housing_units_rehabed'
    'housing_units_weatherized'
    'housing_units_energy_star'
    'housing_units_leed'
    'housing_units_other_green'
]

class ProgramAnnualSurveyReportController

    ### @ngInject ###
    constructor: (@surveys) ->
        @columns = surveyColumns


class AnnualSurveyReportBaseController

    ### @ngInject ###
    constructor: ($timeout, $scope, $state, ApiUrl, FileService) ->
        @scope = $scope
        @timeout = $timeout
        @FileService = FileService
        @ApiUrl = ApiUrl
        @years = getValidYears()

        @scope.refresh = @refresh.bind(@)
        @scope.triggerRefresh = @triggerRefresh.bind(@)

        if $state.current.name == "reports.annualSurvey"
            $state.go '.year', year: @years[0]

    refresh: (params) =>
        @timeout.cancel @refreshTimeout
        @refreshTimeout = @timeout((() => @broadcastRefresh(params)), 10)

    broadcastRefresh: (params) ->
        @lastParams = params
        @scope.$broadcast 'tagRefresh', params

    triggerRefresh: () ->
        if angular.isDefined(@lastParams)
            @refresh @lastParams

    downloadFile: ->
        url = @ApiUrl('reports', 'annual_survey', 'export.xlsx')
        @downloading = true
        @FileService.downloadFile(url, @lastParams).then =>
            @downloading = false


class AnnualSurveyReportYearController

    ### @ngInject ###
    constructor: ($scope, $http, $timeout, $stateParams, $state, ApiUrl) ->
        @scope = $scope
        @http = $http
        @timeout = $timeout
        @state = $state
        @ApiUrl = ApiUrl

        @columns = surveyColumns
        @loading = false

        @sort = $stateParams.sort
        @page = $stateParams.page
        @year = $stateParams.year

        @scope.$on 'tagRefresh', @onTagRefresh
        @scope.$watch (() => @page), @queueLoad
        @scope.triggerRefresh()

    queueLoad: () =>
        @timeout.cancel @queueTimeout
        @timeout (() => @loadData()), 10

    loadData: () ->
        url = @ApiUrl('reports', 'annual_survey', 'year', @year)
        @loading = true

        return if not @tags

        params = angular.extend {}, @tags,
            sort: @sort
            page: @page

        @state.go '.', params, location: 'replace'

        @http.get(url, params: params).then (result) =>
            @loading = false
            @data = result.data.items
            @pager = result.data.pager

    onTagRefresh: (event, tags) =>
        if not angular.equals @tags, tags
            @page = 1 if not @tags
            @tags = tags
            @queueLoad()

    onSortChange: () =>
        @page = 1
        @queueLoad()



module.config annualSurveyStates
module.controller 'ProgramAnnualSurveyReportController', ProgramAnnualSurveyReportController
module.controller 'AnnualSurveyReportBaseController', AnnualSurveyReportBaseController
module.controller 'AnnualSurveyReportYearController', AnnualSurveyReportYearController
